<div class="year-main-page">
    <div class="back-btn" (click)="goToModel()">
        <mat-icon class="go-back-to-model">keyboard_arrow_left</mat-icon>
    </div>
    <div class="container">
    <!-- Steps -->
    <div class="steps">
        <div>Make</div>
        <div (click)="goToModel()">Model </div>
        <div class="active">Year</div>
        <div>Variant</div>
    </div>

    <!-- Heading -->
    <h2 class="gradient-text">Which year of {{ selectedModel }}?</h2>
    <p>Select the manufacturing year of your vehicle</p>

    <!-- Search -->
    <div class="search-box">
        <mat-icon class="material-icons" id="search-icon">search</mat-icon>
        <input type="text" [(ngModel)]="searchText" placeholder="Search for year">
        <mat-icon *ngIf="searchText.trim()" class="material-icons close-btn" (click)="clearSearch()">close</mat-icon>
    </div>
    <!-- <div class="search-box">
        <mat-icon>search</mat-icon>
        <input type="text" [(ngModel)]="searchText" placeholder="Search for your car make">
        <mat-icon (click)="clearSearch()">close</mat-icon>
        </div> -->
    <!-- Year Grid -->
    <div class="year-grid">
        <div *ngFor="let year of filteredYears" class="year-item" (click)="selectYear(year)">
        {{ year.title }}
        </div>
    </div>
    </div>
</div> 
